import { getActionBarStyles } from './componentStyles/ActionBar.styles';
import { getActionCardStyles } from './componentStyles/ActionCard.styles';
import { getM365CheckboxStyles } from './componentStyles/Checkbox.styles';
import { getM365ChoiceGroupStyles } from './componentStyles/ChoiceGroup.styles';
import { getCollapsibleStyles } from './componentStyles/Collapsible.styles';
import { getCompositeStyles } from './componentStyles/CompositeList.styles';
import { getCountAnnotationStyles } from './componentStyles/CountAnnotation.styles';
import { getNavLinkStyles } from './componentStyles/NavLink.styles';
import { getNavLinkGroupStyles } from './componentStyles/NavLinkGroup.styles';
import { getOnboardingHubCardStyles } from './componentStyles/OnBoardingHubCard.styles';
import { getSubwayNavStyles } from './componentStyles/SubwayNav.styles';
import { getTagStyles } from './componentStyles/Tag.styles';
import { getWizardActionBarStyles } from './componentStyles/WizardActionBar.styles';
export const getFluent2ComponentStyles = {
    ActionBar: { styles: getActionBarStyles },
    ActionCard: {
        styles: getActionCardStyles,
    },
    Collapsible: {
        styles: getCollapsibleStyles,
    },
    CompositeList: {
        styles: getCompositeStyles,
    },
    CountAnnotation: {
        styles: getCountAnnotationStyles,
    },
    M365Checkbox: {
        styles: getM365CheckboxStyles,
    },
    M365ChoiceGroup: {
        styles: getM365ChoiceGroupStyles,
    },
    NavLink: {
        styles: getNavLinkStyles,
    },
    NavLinkGroup: {
        styles: getNavLinkGroupStyles,
    },
    OnboardingHubCard: { styles: getOnboardingHubCardStyles },
    SubwayNav: {
        styles: getSubwayNavStyles,
    },
    Tag: {
        styles: getTagStyles,
    },
    WizardActionBar: {
        styles: getWizardActionBarStyles,
    },
};
//# sourceMappingURL=fluent2-components-styles.js.map